import { datadogRum } from '@datadog/browser-rum';
import { useContext } from 'react';
import DatadogRumContext from '../contexts/datadog-rum.js';
export default function useDatadogRum() {
    const rum = useContext(DatadogRumContext);
    if (rum === null) {
        return datadogRum;
    }
    return rum;
}
//# sourceMappingURL=use-datadog-rum.js.map